[...document.querySelectorAll('.js-dropdown')].map(dropdown => {
    let toggle = dropdown.querySelector('.js-dropdown-toggle');

    toggle.addEventListener('click', () => {
        dropdown.classList.toggle('open');
    });
})
